import type { ComponentProps } from 'react';

import { CheckboxField as UadCheckboxField } from '@iconik-io/uad';

type UadCheckboxProps = ComponentProps<typeof UadCheckboxField>;

import { useFieldContext } from '../app_form_context';

export type CheckboxFieldProps = Omit<
  UadCheckboxProps,
  'name' | 'value' | 'isSelected' | 'onChange' | 'onBlur'
>;

export function CheckboxField(props: CheckboxFieldProps) {
  const field = useFieldContext<boolean>();

  return (
    <UadCheckboxField
      name={field.name}
      isSelected={field.state.value}
      onChange={(value) => field.setValue(value)}
      onBlur={field.handleBlur}
      {...props}
    />
  );
}
